(() => {
    "use strict";

    /**
     * Contrato compartilhado de conversão no dataLayer. `generate_lead` é o evento novo;
     * `virtualPageview` na URL de thank-you mantém tags GTM legadas que ainda olham
     * pageview em `/orcamento-enviado` (ou History Change) até o container migrar.
     */
    function pushDataLayer(entry) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(entry);
    }

    function resolveThankYouUrl(thankYouUrl) {
        const url = new URL(thankYouUrl || window.location.href, window.location.origin);
        return url.origin === window.location.origin ? url : new URL(window.location.href);
    }

    window.siteTrackThankYouPageview = function siteTrackThankYouPageview(thankYouUrl) {
        const url = resolveThankYouUrl(thankYouUrl);
        pushDataLayer({
            event: "virtualPageview",
            page_path: url.pathname + url.search,
            page_location: url.href,
            page_title: document.title,
            page_referrer: document.referrer || undefined,
        });
    };

    window.siteTrackGenerateLead = function siteTrackGenerateLead(payload) {
        if (!payload?.form_id) {
            return;
        }
        const pageLocation = payload.page_location || window.location.href;
        const pagePath = payload.page_path || new URL(pageLocation, window.location.origin).pathname;
        pushDataLayer({
            event: payload.event || "generate_lead",
            form_id: payload.form_id,
            form_name: payload.form_name || "",
            page_location: pageLocation,
            page_path: pagePath,
        });
    };

    window.siteTrackLeadConversion = function siteTrackLeadConversion(options) {
        const thankYouUrl = resolveThankYouUrl(options?.thankYouUrl || window.location.href);
        window.siteTrackGenerateLead({
            event: options?.event,
            form_id: options.form_id,
            form_name: options.form_name,
            page_location: thankYouUrl.href,
            page_path: thankYouUrl.pathname,
        });
        if (options?.thankYouPageview !== false) {
            window.siteTrackThankYouPageview(thankYouUrl.href);
        }
        document.dispatchEvent(new CustomEvent("motiveacao:lead-converted", {
            detail: {
                form: options?.form_id || "",
                successUrl: thankYouUrl.href,
            },
        }));
    };
})();
